module.exports = __webpack_public_path__ + "img/teacher.b965dae6.svg";